<template>
  <div class="supply_list" >
    <div class="list_wrap">
      <List v-model="loading" :finished="finished" @load="loadMore"> 
        <div class="item" v-for="(item,index) in list" :key="index" @click="LinkToSupply(item.id)">
          <div class="item_info">
            <img v-if="item.member" :src="item.member.avatarUrl"  v-load="'oPicXS'" >
            <img v-else src="@/assets/img/empty.png" >
            <div class="top_info">
              <div class="info1">
              <span class="name">{{item.member?(item.member.name||item.member.nickName):''}}</span>
                <span class="job">{{item.member?(item.member.title):''}}</span>
              </div>
              <div class="comp_name">{{item.member?item.member.company:''}}</div>
            </div>
            <div class="right_info" v-if="item.memberId!=userInfo.id">
              <div class="like_btn add_like" v-if="!item.isFollow"  @click.stop="addLike(item.id)">关注</div>
              <div class="like_btn" v-else @click.stop="cancelLike(item.id)">已关注</div>
            </div>
          </div>
          <div class="item_top">
            <span>#供需#</span>{{item.content}}
          </div>
          <div class="item_img" v-if="item.imgUrls.length">
            <!-- <img src="https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3995885402,1113893169&fm=26&gp=0.jpg" >
            <img src="https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3995885402,1113893169&fm=26&gp=0.jpg" >
            <img src="https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3995885402,1113893169&fm=26&gp=0.jpg" >
            <img src="https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3995885402,1113893169&fm=26&gp=0.jpg" >
            <img src="https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3995885402,1113893169&fm=26&gp=0.jpg" > -->
            <img  v-for="(imgurl,ind) in item.imgUrls" :key="ind" :src="imgurl" v-load="'oPic'" >
          </div>
          <div class="item_bottom">
            <div class="state_ok">
              <div class="item_count">
                <span>{{item.viewCount}} 阅读</span>
                <span>{{item.commentCount}} 评论</span>
              </div>
              <p>{{item.createAt}}</p>
            </div>
          </div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {  
  name: "supply-list",
  data() {
    return {
      loading: false,   //供需加载状态
      finished: false,  //供需是否完成状态
      list: [],    //供需列表
      pageIndex: 0,
      pageSize:20,
      queryProduct:{},
    };
  },
  components: { List },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId:"getExhibitionId"
    }),
  },
  created() {
  },
  methods: {
    ...mapActions({
      delFollowerSupply:'follower/delFollowerSupply',
      followerSupply:'follower/followerSupply',
      LinkToSupply:'linkTo/LinkToSupply',
    }),
    getList(){
      let query=gql`
      query querySupplyDemandUser($query:QueryInput!,$exhibitionId:Guid!,$memberId:Guid!){
        querySupplyDemandUser(query:$query,exhibitionId:$exhibitionId){
          hasNextPage
          indexFrom
          pageIndex
          pageSize
          items{
            supplyDemand{
              content 
              createAt
              memberId
              id
              userCount
              commentCount
              isFollow(memberId:$memberId)
              imgUrls
              viewCount
              member{
                avatarUrl
                name
                nickName
                title
                company
              }
            }
          }
        }
      }`
      let where={
        "Equal":{
          "n":"memberId",
          "v":this.userInfo.id
        },
        // "EqualB":{
        //   "n":"exhibitionId",
        //   "v":this.exhibitionId
        // }
      }
      let order=[
        {
          "N":"createAt",
          "v":0
        }
      ]
      let opt={
        page:this.pageIndex,
        size:this.pageSize,
        where:JSON.stringify(where),
        order:JSON.stringify(order)
      }
      this.$apollo.addSmartQuery("querySupplyDemandUser",{ 
        query:query,
        variables:{
         query:opt,
         exhibitionId:this.exhibitionId,
         memberId:this.userInfo.id
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          this.finished = true;
          this.loading=false;
          let res=JSON.parse(JSON.stringify(data.data.querySupplyDemandUser));
          // let res=data.data.queryProduct;
          console.log('供需浏览',res);
          let items=[]
          if(res&&res.items.length){
            res.items.forEach(el => {
              if(el.supplyDemand){
                items.push(el.supplyDemand);
              }
            });
          }
          if(items.length){
            items.forEach(e => {
              e.createAt=moment(e.createAt).format('YYYY/MM/DD HH:mm:ss');
              // console.log(e.imgUrls,'img');
              if(e.imgUrls){
                e.imgUrls=e.imgUrls.split(';')
              }else{
                e.imgUrls=[]
              }
            });
          }
          if(this.pageIndex==1){
            this.list=items
          }else{
            this.list=[...new Set([...this.list,...items])];
          }
          this.loading=false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.loading=false;
          this.finished = true;
          console.log('err',err)
        }
      })
      // setTimeout(()=>{
      //   this.list=[...this.list,...this.list];
      //   this.loading=false;
      //   if(this.list.length>20){
      //     this.finished=true
      //   }
      // },1000)
    },
    loadMore(){
      if(this.finished) return;
      this.pageIndex+=1;
      this.getList();
    },
    //取消关注
    async cancelLike(id){
      let opt={
        DemandId:id,
        memberId:this.userInfo.id
      }
      console.log(opt,'opt')
      let res=await this.delFollowerSupply(opt);
      if(res.result){
        this.list.map(c=>{
          if(id === c.id){
            c.isFollow = false;
          }
        })
        this.$toast.success('取消关注');
      }else{
        this.$toast.fail('取消失败 ');
      }
    },
    //关注
    async addLike(id){
      let user={
        name:this.userInfo.name,
        nickName:this.userInfo.nickName,
        avatarUrl:this.userInfo.avatarUrl,
        jobTitle:this.userInfo.jobTitle
      }
      let opt={
        supplyDemandId:id,
        memberId:this.userInfo.id,
        userInfo:JSON.stringify(user)
      };
      let res= await this.followerSupply(opt);
      if(res.result){
        this.$toast.success('已关注');
        if(id){
          this.list.map(c=>{
            if(id === c.id){
              c.isFollow = true;
            }
          })
        }
      }else{
        this.$toast.fail('关注失败 ');
      }
    }
  }
};
</script>

<style scoped lang="scss">
//展品列表
.supply_list{
  padding: 0.3rem 0.3rem 0;
  .list_wrap{
    .item{
      background-color: #fff;
      margin-bottom: 0.3rem;
      box-shadow: 0 0  0.1rem 0
      rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      padding:0.2rem;
      .item_info{
        margin-bottom: 0.2rem;
        display: flex;
        img{
          flex-shrink:0;
          display: block;
          width: 0.6rem;
          height: 0.6rem;
          box-sizing: border-box;
          border: 1px solid #e6e6e6;
          border-radius: 50%;
          // object-fit: cover;
          margin-right: 0.15rem;
        }
        .top_info{
          width: calc(100% - 1.95rem);
          color: #666;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .info1{
            display: flex;
            align-items: flex-end;
            .name {
              font-size: 0.22rem;
              margin-right: 0.1rem;
              font-weight: bold;
              color: #333;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            .job {
              flex-shrink: 0;
              font-size: 0.18rem;
            }
          }
          .comp_name{
            font-size: 0.2rem;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
        .right_info{
          flex-shrink:0;
          margin-left: auto;
          display: flex;
          align-items: center;
          .like_btn{
            height: 0.48rem;
            width: 1.1rem;
            border: solid 1px #ff5c00;
            border-radius: 0.26rem;
            color: #ff5c00;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            &.add_like{
              color: #fff;
              background: #ff5c00;
            }
          }
        }
      }
      .item_top{
        font-size: 0.26rem;
        // font-weight: bold;
        color: #333;
        line-height:0.4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        span{
          color:#f85b0f;
          font-size: 0.26rem;
          margin-right: 0.05rem;
        }
      }
      .item_img{
        display: flex;
        margin-top: 0.2rem;
        img{
          width: 1.1rem;
          height: 1.1rem;
          margin-right: 0.1rem;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      .item_bottom{
        *{
          font-size: 0.22rem;
        }
        margin-top: 0.3rem;
        .state_ok{
          display: flex;
          justify-content: space-between;
          color: #666;
          .item_count{
            span{
              margin-right:0.3rem;
              &:last-child{
                margin-right: 0;
              }
            }
           
          }
        }
        .item_state{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .state0{
            color: #ff9752;
            &.state-1{
              color:#ff563a;
            }
          }
          .state_no{
            display: flex;
            align-items: center;
            span{
              color:#ff563a;
              margin-right: 0.3rem;
            }
            div{
              padding: 0.05rem 0.2rem;
              border-radius: 0.05rem;
              background: #ff954f;
              color: #fff;
            }
          }
        }
      }      
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
